import { render, staticRenderFns } from "./Anchor.vue?vue&type=template&id=8dfd9932&scoped=true"
import script from "./Anchor.js?vue&type=script&lang=js&external"
export * from "./Anchor.js?vue&type=script&lang=js&external"
import style0 from "./Anchor.scss?vue&type=style&index=0&id=8dfd9932&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dfd9932",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HotLink: require('/home/runner/_work/app-hotmart-legal/app-hotmart-legal/components/Atoms/Link/Link.vue').default})
